export enum ReferAndEarnAction {
  PAGE_VIEWED = "PAGE_VIEWED",
  REFER_PROFESSIONALS_CLICKED = "REFER_PROFESSIONALS_CLICKED",
  REFER_WORKPLACES_CLICKED = "REFER_WORKPLACES_CLICKED",
  BACK_BUTTON_CLICKED = "BACK_BUTTON_CLICKED",
}
